import axios from 'axios';
import { config } from '../config/config';
import { getAuth } from 'firebase/auth';

const getAuthHeaders = async () => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const accountService = {
  async getUserProfile(userId) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.get(`${config.apiUrl}/account/profile/${userId}`, authConfig);
      return response.data;
    } catch (error) {
      console.error('Error getting user profile:', error);
      throw error;
    }
  },
  
  async createUserProfile(userId, profileData) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.post(`${config.apiUrl}/account/profile/${userId}`, profileData, authConfig);
      return response.data;
    } catch (error) {
      console.error('Error creating user profile:', error);
      throw error;
    }
  },

  async updateUserProfile(userId, profileData) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.put(`${config.apiUrl}/account/profile/${userId}`, profileData, authConfig);
      return response.data;
    } catch (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
  },

  async getUserSubscription(userId) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.get(`${config.apiUrl}/account/subscription/${userId}`, authConfig);
      return response.data;
    } catch (error) {
      console.error('Error getting user subscription:', error);
      throw error;
    }
  },

  async updateSubscription(userId, subscriptionData) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.post(`${config.apiUrl}/account/subscription/${userId}`, subscriptionData, authConfig);
      return response.data;
    } catch (error) {
      console.error('Error updating subscription:', error);
      throw error;
    }
  },

  async checkSubscriptionStatus(userId) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.get(`${config.apiUrl}/account/subscription/status/${userId}`, authConfig);
      return response.data;
    } catch (error) {
      console.error('Error checking subscription status:', error);
      throw error;
    }
  },

  async deleteAccount(userId) {
    try {
      const authConfig = await getAuthHeaders();
      const response = await axios.delete(`${config.apiUrl}/account/${userId}`, authConfig);
      return response.data;
    } catch (error) {
      console.error('Error deleting account:', error);
      throw error;
    }
  },

};

// eslint-disable-next-line import/no-anonymous-default-export
export default accountService; 